import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { TimeToNowModule } from '@rma/dashboard/generic/util/pipes/time-to-now';
import { GenericDataModel, UserNotificationModel } from '@rma/dashboard/notification-bell/private/api-user-notifications';
import { NotificationRouteData } from '@rma/dashboard/notification-bell/private/util-notification-content';

@Component({
  selector: 'rma-notification-item-generic',
  templateUrl: 'notification-item-generic.component.html',
  styleUrls: ['notification-item-generic.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatBadgeModule,
    MatButtonModule,
    MatMenuModule,
    NgTemplateOutlet,
    RouterModule,
    StaticImageUrlPipe,
    TimeToNowModule,
    TranslocoModule,
  ],
})
export class NotificationItemGenericComponent {
  @HostBinding() class = 'block';

  @Input() public notification: UserNotificationModel;
  @Input() public containerClass?: string;

  @Output() public navigate = new EventEmitter<NotificationRouteData>();

  public get data(): GenericDataModel {
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    return this.notification.data as GenericDataModel;
  }
}
